import { motion } from 'motion/react';
import { Outlet, useLocation } from 'react-router-dom';
import { env } from '../../config/env';
import { SiteFooter } from './SiteFooter';
import { SiteHeader } from './SiteHeader';

export function AppLayout() {
  const location = useLocation();
  return (
    <>
      <a className="skip-link" href="#main-content">Saltar al contenido</a>
      <SiteHeader />
      {!env.firebaseConfigured && import.meta.env.DEV && (
        <div className="config-banner" role="status">
          Modo visual: configura <code>.env.local</code> para activar Firebase y los emuladores.
        </div>
      )}
      <motion.main
        id="main-content"
        key={location.pathname}
        className="page-shell"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.35 }}
      >
        <Outlet />
      </motion.main>
      <SiteFooter />
    </>
  );
}
